import { useTranslation } from 'react-i18next'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

interface MarkCompleteConfirmDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    objectID: string
    objectDescription: string | null
    onConfirm: () => void
    isLoading?: boolean
}

export function MarkCompleteConfirmDialog({
    open,
    onOpenChange,
    objectID,
    objectDescription,
    onConfirm,
    isLoading = false,
}: MarkCompleteConfirmDialogProps) {
    const { t } = useTranslation()

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>{t('myAssignments.markCompleteTitle')}</DialogTitle>
                    <DialogDescription>
                        {t('myAssignments.markCompleteConfirm', { objectID })}
                    </DialogDescription>
                </DialogHeader>
                {objectDescription && (
                    <p className="text-sm text-muted-foreground">{objectDescription}</p>
                )}
                <DialogFooter className="gap-2">
                    <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isLoading}>
                        {t('common.cancel')}
                    </Button>
                    <Button onClick={onConfirm} disabled={isLoading} className="bg-green-600 hover:bg-green-700">
                        {isLoading ? t('common.loading') : t('myAssignments.markComplete')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
